import { Spinner } from '@cuc/ui/kit';

export const LoadingScreen = () => (
  <div className="flex h-full items-center justify-center">
    <Spinner size="large" />
  </div>
);
